// https://github.com/typestack/class-validator/pull/258
module.exports = {
    PhoneNumberUtil: {
        getInstance() {
            return null;
        },
    },
};
